import type { ComponentMeta } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { TextBlock } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { color } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/color";
import { fontStyle } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontStyle";
import { fontWeight } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/fontWeight";
import { lineHeight } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/lineHeight";
import { margin } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/margin";
import { padding } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/padding";
import { textAlign } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/textAlign";
import { textDecoration } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/textDecoration";
import { textTransform } from "@circle-react-shared/BuilderUI/constants/DefaultStyleAttributes/textTransform";
import {
  ContentProp,
  DesignProp,
  GeneralProp,
  MarginsProp,
  PaddingsProp,
} from "@circle-react-shared/BuilderUI/constants/PropCategories";
import { fontSize } from "../../../ModifiedStyleAttributes/fontSize";
import { p1DefaultStyles as defaultStyles } from "./defaultStyles";

export const meta: ComponentMeta = {
  name: "Paragraph",
  nameI18n: "builder_ui.block_type.p",
  version: 1,
  category: [TextBlock],
  props: {
    text: {
      name: "Text",
      nameI18n: "builder_ui.prop_type.text",
      category: [ContentProp],
      prop: "other",
      type: "rich-text",
    },
    paragraphStyle: {
      name: "Paragraph Style",
      nameI18n: "builder_ui.prop_type.paragraph_style",
      category: [ContentProp],
      prop: "other",
      type: "paragraph-style-picker",
      defaultValue: "p1",
    },
    styles: {
      name: "Styles",
      nameI18n: "builder_ui.prop_type.styles",
      category: [DesignProp],
      prop: "custom",
      type: "paragraph",
      attributes: {
        color: {
          ...color,
          type: "color-without-alpha",
          defaultValue: defaultStyles.color,
          category: [DesignProp, GeneralProp],
        },
        textTransform: {
          ...textTransform,
          defaultValue: defaultStyles.textTransform,
          category: [DesignProp, GeneralProp],
        },
        fontStyle: {
          ...fontStyle,
          defaultValue: defaultStyles.fontStyle,
          category: [DesignProp, GeneralProp],
        },
        fontWeight: {
          ...fontWeight,
          defaultValue: defaultStyles.fontWeight,
          category: [DesignProp, GeneralProp],
        },
        fontSize: {
          ...fontSize,
          defaultValue: defaultStyles.fontSize,
          category: [DesignProp, GeneralProp],
        },
        lineHeight: {
          ...lineHeight,
          defaultValue: defaultStyles.lineHeight,
          category: [DesignProp, GeneralProp],
        },
        textAlign: {
          ...textAlign,
          defaultValue: defaultStyles.textAlign,
          category: [DesignProp, GeneralProp],
        },
        textDecoration: {
          ...textDecoration,
          defaultValue: defaultStyles.textDecoration,
          category: [DesignProp, GeneralProp],
        },
        margin: {
          ...margin,
          defaultValue: defaultStyles.margin,
          category: [DesignProp, MarginsProp],
        },
        padding: {
          ...padding,
          defaultValue: defaultStyles.padding,
          category: [DesignProp, PaddingsProp],
        },
      },
    },
  },
};
